import { render, staticRenderFns } from "./FAMSIOTNotificationDashboard.vue?vue&type=template&id=46bd3964"
import script from "./FAMSIOTNotificationDashboard.vue?vue&type=script&lang=js"
export * from "./FAMSIOTNotificationDashboard.vue?vue&type=script&lang=js"
import style0 from "./FAMSIOTNotificationDashboard.vue?vue&type=style&index=0&id=46bd3964&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports